import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import Modal from 'components/modal/Modal/Modal'
import RemindPasswordForm from 'pages/auth/RemindPasswordPage/RemindPasswordForm/RemindPasswordForm'

import messages from './messages'
import s from './RemindPasswordModal.scss'


class RemindPasswordModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.RemindPassword,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        className={s.remindPasswordModal}
        name={name}
        title={messages.title}
        onClose={this.handleClose}
        titleUppercase
      >
        <RemindPasswordForm onClickBackLink={this.handleClose} />
      </Modal>
    )
  }
}


export default RemindPasswordModal
